import React from "react";
import "./confirm-modal.css";

const ConfirmModal = ({ isOpen, onClose, onConfirm, message, title }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="confirm-modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title || "Xác nhận thao tác"}
      >
        <h2 className="confirm-modal-title">{title || "Xác nhận thao tác"}</h2>
        <p className="confirm-modal-message">{message || "Bạn có chắc muốn tiếp tục?"}</p>
        <div className="confirm-modal-buttons">
          <button type="button" className="confirm-modal-cancel-btn" onClick={onClose}>
            Hủy
          </button>
          <button type="button" className="confirm-modal-confirm-btn" onClick={onConfirm}>
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
